import { Theme } from '@mirai/ui';

export const getStyle = () => {
  const { content, font, inputDisabled, inputFontSize } = Theme.get();

  return {
    styles: {
      '*': {
        color: content,
        fontFamily: font,
        fontSize: `${inputFontSize}px`,
        letterSpacing: 0,
      },
      '*::placeholder': `color:${inputDisabled}`,
      cardNumber: 'border: 0; outline: 0; padding: 0;',
      cvv: 'border: 0; outline: 0; padding: 0;',
    },
  };
};
